import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useTheme,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  Box,
  Button,
  Divider,
  styled,
} from '@mui/material';
import { Flight } from '@mui/icons-material';
import Close from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ChevronLeft from '@mui/icons-material/ChevronLeft';

import { routes } from '../routes';

const CacaBox = styled(Box)`
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.alphas.cascote};
  background: ${({ theme }) => theme.palette.alphas.piedrazo};
`;

const HardcodedLatamLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="20" viewBox="0 0 88 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.383 14.9707L73.0263 4.98131H75.9489C75.9489 4.98131 76.6901 4.91151 77.0713 5.20688C77.4525 5.50228 77.5606 5.95876 77.5606 5.95876L79.1486 10.793L81.2207 4.98141H84.0488C84.0488 4.98141 84.7522 4.98141 85.1167 5.26069C85.4813 5.53998 85.5908 5.95889 85.5908 5.95889L87.9091 14.971H85.1631L83.0918 7.28942L80.9179 13.1452H78.007C78.007 13.1452 77.6562 13.1787 77.3209 12.9572C76.9856 12.7356 76.975 12.5329 76.975 12.5329L75.2029 7.28974L73.1696 14.9713L70.383 14.9707ZM43.1538 4.98002V6.97256L48.0582 7.2948V14.9696H50.8908V7.2948L55.7953 6.97256V4.98002H43.1538ZM35.0029 4.98002L29.8948 14.9695H33.0347L33.927 13.1327H39.6224L40.4943 14.9695H43.6168L38.7707 5.63514C38.7707 5.63514 38.6124 5.29134 38.3377 5.13766C38.0631 4.98402 37.7741 4.97989 37.7741 4.97989H35.0028L35.0029 4.98002ZM36.7372 7.13719L38.6143 11.1027H34.8307L36.7371 7.13719H36.7372ZM19.1074 4.98002V14.9695H27.7309L28.9063 12.6708H22.0625V4.97992L19.1074 4.98002ZM60.4765 4.98002L55.3684 14.9695H58.5084L59.4007 13.1327H65.0961L65.968 14.9695H69.0904L64.2443 5.63514C64.2443 5.63514 64.086 5.29134 63.8114 5.13766C63.5368 4.98402 63.2478 4.97989 63.2478 4.97989H60.4764L60.4765 4.98002ZM62.2108 7.13719L64.088 11.1027H60.3044L62.2108 7.13719H62.2108Z"
      fill="#2A0088"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.55246 8.19014L3.81934 7.557C3.81934 7.557 3.79506 7.40897 3.71379 7.3363C3.63249 7.26364 3.4863 7.21868 3.4863 7.21868L0.33558 6.09967C0.33558 6.09967 0.23556 6.0668 0.162465 6.10638C0.0894022 6.14592 0.0919728 6.24871 0.0919728 6.24871V7.68135C0.0919728 7.68135 0.0841293 7.81853 0.2873 8.12598C0.490504 8.4334 0.971787 8.35509 0.971787 8.35509L1.55246 8.19014ZM10.5767 4.73347L12.6854 3.57831C12.6854 3.57831 12.7171 3.37871 12.6358 3.30605C12.5545 3.23338 12.4578 3.21099 12.4578 3.21099L3.35085 0.0333156C3.35085 0.0333156 3.25083 0.000447182 3.17773 0.0400182C3.10467 0.0795571 3.10724 0.182384 3.10724 0.182384V1.41763C3.10724 1.41763 3.10599 1.70384 3.30916 2.01129C3.51236 2.3187 3.84205 2.3983 3.84205 2.3983L10.5767 4.73347ZM10.5767 8.32903L12.6854 7.26086C12.6854 7.26086 12.7303 6.99038 12.649 6.91771C12.5677 6.84505 12.4578 6.80657 12.4578 6.80657L0.335415 2.50112C0.335415 2.50112 0.235395 2.46826 0.1623 2.50783C0.0892374 2.5474 0.091808 2.65026 0.091808 2.65026V3.88547C0.091808 3.88547 0.0905557 4.17168 0.293727 4.47913C0.496931 4.78658 0.826618 4.86617 0.826618 4.86617L10.5767 8.32903Z"
      fill="#ED1651"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4578 3.21094C12.4578 3.21094 12.5808 3.22921 12.6853 3.32855C12.7897 3.4279 12.7908 3.54926 12.7908 3.54926V5.18475C12.7908 5.18475 12.7858 5.40819 12.6921 5.60914C12.5983 5.81009 12.4611 5.85762 12.4611 5.85762L12.1754 5.95906L3.07442 9.19145C3.07442 9.19145 3.03066 9.20466 2.97374 9.20466C2.9168 9.20466 2.87303 9.19145 2.87303 9.19145L0.337332 8.29082C0.337332 8.29082 0.27442 8.27651 0.185176 8.13979C0.0846619 7.9864 0.0919121 7.68189 0.0919121 7.68189C0.0919121 7.68189 0.107665 7.83804 0.197897 7.91216C0.288129 7.98627 0.528672 7.90494 0.528672 7.90494L12.1755 3.76835C12.1755 3.76835 12.638 3.5839 12.638 3.39648C12.638 3.26704 12.4578 3.21149 12.4578 3.21149L12.4578 3.21094ZM12.4578 6.80649C12.4578 6.80649 12.5808 6.82476 12.6853 6.92411C12.7897 7.02345 12.7908 7.14481 12.7908 7.14481V8.7803C12.7908 8.7803 12.7858 9.00375 12.6921 9.20469C12.5983 9.40564 12.4611 9.45317 12.4611 9.45317L12.1754 9.55461L3.07442 12.787V10.5958L12.1754 7.36338C12.1754 7.36338 12.6379 7.17893 12.6379 6.99152C12.6379 6.86208 12.4578 6.80649 12.4578 6.80649ZM7.93988 12.563C8.02698 12.6481 8.02698 12.8356 8.02698 12.8356V14.0586C8.02698 14.0586 8.02197 14.282 7.92825 14.483C7.83449 14.6839 7.69723 14.7314 7.69723 14.7314L7.4116 14.8329L3.07432 16.3734V14.1822L7.4116 12.6417C7.4116 12.6417 7.85278 12.4778 7.93988 12.563V12.563ZM5.14195 17.1362C5.22906 17.2214 5.22906 17.4088 5.22906 17.4088V18.6318C5.22906 18.6318 5.22405 18.8553 5.13032 19.0562C5.03656 19.2572 4.8993 19.3047 4.8993 19.3047L4.61368 19.4061L3.07432 19.9799V17.7887L4.61368 17.2149C4.61368 17.2149 5.05485 17.0511 5.14195 17.1362V17.1362Z"
      fill="#2A0088"
    />
  </svg>
);

// TODO: Placeholder. Refactorear para matchear UI del voucher de flights.
export const FlightVoucher = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  // TODO: Esto eventualmente deberia ser un payment id
  // const { id } = useParams<{ id: string }>();

  // const queryParams = useMemo(() => (id ? { id: parseInt(id, 10) } : { id: 0 }), [id]);

  const goHome = useCallback(() => {
    navigate(routes.flights.index);
  }, [navigate]);

  const mockedPassengers = [
    { id: 1, name: 'Natalia Oreiro', ticket: '2ADX6B' },
    { id: 2, name: 'Nicole Cucco', ticket: '2ADX6A' },
    { id: 3, name: 'Ricardo Montaner', ticket: '2ADX6C' },
    { id: 4, name: 'Catherine Fulop', ticket: '2ADX6D' },
  ];

  // TODO: get from api and itinerary id from booking
  const mockedItinerary = {
    id: 1,
    departureAirport: 'MVD',
    departureAirportName: 'Aeropuerto internacional de Carrasco',
    departureTime: '2024-07-31 20:50:00+00',
    arrivalAirport: 'CUN',
    arrivalAirportName: 'Aeropuerto Internacional Jorge Chávez',
    arrivalTime: '2024-08-01 06:05:00+00',
  };

  return (
    <Box>
      <AppBar position="static" style={{ backgroundColor: '#5e2590' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="back">
            <Close />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1 }}>
            Voucher
          </Typography>
          <IconButton color="inherit">
            <MoreVertIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box display="flex" justifyContent="center" alignItems="center" mt={3}>
        <Card elevation={4} sx={{ maxWidth: 360, marginTop: theme.spacing(2) }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight="500" gutterBottom>
              {t('flights.voucher.card')}
            </Typography>
            <Typography variant="caption" component="p">
              {t('flights.voucher.localizer')}: 2ADX6F
            </Typography>
            <Typography variant="caption" component="p" gutterBottom>
              {t('flights.voucher.agency')}: Mevuelo.com
            </Typography>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
              <HardcodedLatamLogo />
              <Box textAlign="right">
                <Typography variant="caption" component="p" color="primary.main">
                  4 {t('flights.voucher.sits')}
                </Typography>
                <Typography variant="caption" component="p">
                  12h 40m
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              paddingY={theme.spacing(2)}
              borderBottom={`1px dashed ${theme.palette.alphas.divider}`}
              borderTop="1px dashed var(--divider, rgba(0, 0, 0, 0.12))"
            >
              {mockedPassengers.map(({ id, name, ticket }) => (
                <Box key={id} display="flex" justifyContent="space-between">
                  <Typography variant="caption" component="p">
                    Pasajero: {name}
                  </Typography>
                  <Typography variant="caption" component="p">
                    N° billete: {ticket}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
              <Box>
                <Typography variant="h5" component="p">
                  {mockedItinerary.departureAirport}
                </Typography>
                <Typography variant="caption" component="p">
                  {mockedItinerary.departureAirportName}
                </Typography>
              </Box>
              <Box>
                <Flight
                  style={{
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.main,
                    transform: 'rotate(90deg)',
                  }}
                />
              </Box>
              <Box>
                <Typography variant="h5" component="p" textAlign="right">
                  {mockedItinerary.arrivalAirport}
                </Typography>
                <Typography variant="caption" component="p" textAlign="right">
                  {mockedItinerary.arrivalAirportName}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              borderBottom={`1px dashed ${theme.palette.alphas.divider}`}
              pb={theme.spacing(2)}
            >
              <Box display="flex" justifyContent="space-between" gap={theme.spacing(2)} my={theme.spacing(1)}>
                <CacaBox>
                  <Typography variant="subtitle1">{t('flights.voucher.departure')}</Typography>
                  <Typography variant="caption" component="p">
                    09:00 AM
                  </Typography>
                  <Typography variant="caption" component="p">
                    14 Mar, 2023
                  </Typography>
                </CacaBox>

                <CacaBox>
                  <Typography variant="subtitle1">{t('flights.voucher.arrival')}</Typography>
                  <Typography variant="caption" component="p">
                    06:00 PM
                  </Typography>
                  <Typography variant="caption" component="p">
                    15 Mar, 2023
                  </Typography>
                </CacaBox>
              </Box>

              <Box display="flex" justifyContent="space-between" gap={theme.spacing(2)} my={theme.spacing(1)}>
                <CacaBox>
                  <Typography variant="subtitle1">{t('flights.voucher.sits')}</Typography>
                  <Typography variant="caption" component="p">
                    A1, B1, C1, D1
                  </Typography>
                </CacaBox>

                <CacaBox>
                  <Typography variant="subtitle1">{t('flights.voucher.terminal')}</Typography>
                  <Typography variant="caption" component="p">
                    T3
                  </Typography>
                </CacaBox>

                <CacaBox>
                  <Typography variant="subtitle1">{t('flights.voucher.gate')}</Typography>
                  <Typography variant="caption" component="p">
                    54
                  </Typography>
                </CacaBox>
              </Box>
            </Box>
            <Box mt={3} display="flex" justifyContent="center">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<ChevronLeft />}
                endIcon={<HomeIcon />}
                onClick={goHome}
                sx={{ backgroundColor: '#5e2590' }}
              >
                {t('flights.voucher.gohome')}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};
